import { Dispatch } from "../../config/controller";
import { Model,StateProps } from "../../config/model";


export interface StatusAppState extends StateProps<any> {
    start:boolean
    versao:string
}


export interface StatusAppActions extends Dispatch<any> {
    startApp:()=>any
}

const model = new Model<any,StatusAppState>("statusapp");


export const initialValueStatusAppState:StatusAppState = {
    ...model.getInititalValueState(),
    start:false,
    versao:"0.0.2"
}


